import { Counter } from './counter';
import { ProductPackValidator } from './product-pack-validator';
import { Product } from '../../order/models/product';

export class ProductPack {
  name: string;
  description: string;
  iconUrl: string;
  infoHtml: string;

  productDescription: string;
  private _counters: Counter[];
  private _products: Product[];
  public hasError = false;
  sequence: number;

  private _isPinRequired: boolean = true;

  selectedVariantProduct: Product;
  variantsProducts: Product[];

  constructor(name: string,
    description: string,
    info: string,
    counters: Counter[],
    iconUrl = '',
    productDescription: string,
    products?: Product[],
    sequence: number = 1,
  ) {
    this.name = name;
    this.description = description;
    this.iconUrl = iconUrl;
    this.infoHtml = info;
    this._counters = counters ? counters : [];
    this._products = products;
    this.sequence = sequence;
    this.productDescription = productDescription;
  }

  get counters(): Counter[] {
    return this._counters ? this._counters : [];
  }

  get countersSorted(): Counter[] {
    return this.counters.sort((a, b) => b.id - a.id);
  }

  addCounter(counter: Counter) {
    this._counters.push(counter);
  }

  get error(): string {
    return ProductPackValidator.getError(this.counters);
  }

  get products(): Product[] {
    return this._products;
  }

  get totalPrice(): number {
    if (this.variantsProducts?.length > 0) {
      return this.selectedVariantProduct?.price || 0;
    }

    return this.products ? this.products.reduce((a, b) => a + b.price, 0) : 0;
  }

  get isLocked(): boolean {
    return this.isPinRequired && this.counters.reduce((a, b) => a + b.count, 0) <= 0;
  }

  get requiredPinProduct(): Product {
    return this.products?.find(product => product.isPinRequired);
  }

  get isPinRequired(): boolean {
    return this._isPinRequired && this.requiredPinProduct != null;
  }

  setUnlocked(): void {
    this._isPinRequired = false;
  }

  get productSaleDescription(): string {
    return this.products?.length > 0 ? this.products[0].saleDescription : '';
  }

  selectVariantProduct(variantProductId: any, count: number = null): void {
    if (!this.variantsProducts) {
      return;
    }

    this.selectedVariantProduct = this.variantsProducts.find(product => product.id === variantProductId);
    this.updateCounter(this.selectedVariantProduct, count);
    this.updateName(this.selectedVariantProduct);
  }

  updateCounter(product: Product, count: number = null): void {
    if (!product || !this._counters || this._counters.length !== 1) {
      return;
    }

    this._counters[0].id = product.id;
    this._counters[0].tag = product;
    if (count != null) {
      this._counters[0].count = count;
    }
  }

  updateName(product: Product): void {
    if (!product) {
      return;
    }
    const name = product.attributes['name'];
    if (name) {
      this.name = name;
    }
  }
}
